import { ProductType } from '@inter-ikea-storageone/range';
import CategoryAdditionalInlineMessage from 'components/ProductSidebar/CategoryWidget/CategoryAdditionalInlineMessage';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/ivar/behaviors/addProduct';
import withInlineMessage from 'rangeConfig/shared/widgets/withInlineMessage';
import { isMobile } from 'utils/platform';

const sectionsProductListConfig: ProductListConfig = {
  cardsSubtitle: 'communicatedSizeText',
  mobileCardText: 'communicatedSizeText',
  categories: [
    {
      id: 'sections-30',
      categoryTitle:
        'storageone.depth communicatedDimensionsLocalized.depth communicatedDimensionsLocalized.unit',
      products: [
        { path: 'type', value: ProductType.IVAR_SECTION },
        { path: 'communicatedDimensions.depth', value: 300 }
      ],
      widgets: [
        {
          component: withInlineMessage(
            'storageone.ivarSectionsInlineMessageDescription',
            false,
            'storageone.ivarSectionsInlineMessageTitle'
          )(CategoryAdditionalInlineMessage),
          hidden: () => !isMobile()
        }
      ]
    },
    {
      id: 'sections-30',
      products: [
        { path: 'type', value: ProductType.IVAR_CORNER_SECTION_W_SHELVES },
        { path: 'communicatedDimensions.depth', value: 300 }
      ]
    },
    {
      id: 'sections-50',
      categoryTitle:
        'storageone.depth communicatedDimensionsLocalized.depth communicatedDimensionsLocalized.unit',
      products: [
        { path: 'type', value: ProductType.IVAR_SECTION },
        { path: 'communicatedDimensions.depth', value: 500 }
      ]
    },
    {
      id: 'sections-50',
      products: [
        { path: 'type', value: ProductType.IVAR_CORNER_SECTION_W_SHELVES },
        { path: 'communicatedDimensions.depth', value: 500 }
      ]
    }
  ],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  cluster: [],
  sortOrder: []
};

export default sectionsProductListConfig;
